export default __webpack_public_path__ + "static/media/logout_icon.af64c4ad.svg";